import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button/index'

const StyledButton = styled(Button)(
  ({ theme, size }) => `
  && {
    display: block;
    margin-left: auto;
    min-width: 210px;
    font-weight: 500;
    margin-top: 14px;
    font-size: ${theme.typography.pxToRem(18)};
    ${size === 'small' ? 'min-height: 42px;' : ''}
  }
`
)

const PrimaryButton = ({ children, ...props }) => (
  <StyledButton variant="contained" color="primary" {...props}>
    {children}
  </StyledButton>
)

PrimaryButton.propTypes = {
  children: PropTypes.node,
}

export default React.memo(PrimaryButton)
